import * as React from "react"
import Helmet from "react-helmet"

function SEO() {
    return (
          <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
          <meta name="theme-color" content="#ffffff"/>
          <meta name="msapplication-TileColor" content="#da532c"/>
          <meta name="theme-color" content="#ffffff"/>
          <title>{"Bookchain®️ Reader"}</title>
          </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
}

export default SEO
